export default "__VITE_ASSET__C9KJ8ixM__ 720w";